import React from 'react';
import './banner.css';
import { Link } from 'react-router-dom';
import coronaImg from '../../assets/Mega Menu Icons.svg';
import { openInNewTab } from '../../util/outsideAlert';

const Banner = () => {
  return (
    <div className="banner">
      <div className="cta">
        <div className="banner-left-wrap">
          <img src={coronaImg} alt="img" className="banner-icon" />
          <span className="banner-text">
            Quick and reliable COVID-19 testing.
          </span>
          <Link
            to="#"
            onClick={() =>
              openInNewTab('https://bookmytest.ca/services/5198246445')
            }
            className="covid-link"
          >
            Covid-19 Test
          </Link>
        </div>
        <div className="banner-right-wrap">
          <Link to="/Contact" className="new-link-banner">
            Contact us
          </Link>
          <Link to="/auth/login" className="new-link-banner">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner;
